var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Shop users")]),_c('div',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n    "+_vm._s(_vm.$route.params.id)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }